import { render, staticRenderFns } from "./add-image.vue?vue&type=template&id=5da10045&scoped=true&"
import script from "./add-image.vue?vue&type=script&lang=js&"
export * from "./add-image.vue?vue&type=script&lang=js&"
import style0 from "./add-image.vue?vue&type=style&index=0&id=5da10045&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da10045",
  null
  
)

export default component.exports